import React from 'react';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import ScaleOutlinedIcon from '@mui/icons-material/ScaleOutlined';
import CategoryIcon from '@mui/icons-material/Category';
import { formatCurrency } from '../../utils/formatters';
import KpisBar, { type KpiBarItem } from './KpisBar';

export type DocumentosKpisBarProps = {
  cantidad: number;
  cantidadLabel: string;
  precioTotal: number;
  precioNeto: number;
  pesoTotalKg: number;
  volumenTotalM3: number;
  ariaLabel?: string;
};

const formatPesoKg = (kg: number): string =>
  `${new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(kg || 0)} kg`;

const formatVolumenM3 = (m3: number): string =>
  `${new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  }).format(m3 || 0)} m³`;

const DocumentosKpisBar: React.FC<DocumentosKpisBarProps> = ({
  cantidad,
  cantidadLabel,
  precioTotal,
  precioNeto,
  pesoTotalKg,
  volumenTotalM3,
  ariaLabel,
}) => {
  const items: KpiBarItem[] = [
    {
      key: 'cantidad',
      icon: <Inventory2OutlinedIcon sx={{ fontSize: 20 }} />,
      iconColor: '#757575',
      value: String(cantidad),
      label: cantidadLabel,
    },
    {
      key: 'total',
      icon: <AttachMoneyIcon sx={{ fontSize: 20 }} />,
      iconColor: '#2e7d32',
      value: formatCurrency(precioTotal),
      valueColor: '#2e7d32',
      label: 'precio total',
    },
    {
      key: 'neto',
      icon: <PriceCheckIcon sx={{ fontSize: 20 }} />,
      iconColor: '#00897b',
      value: formatCurrency(precioNeto),
      valueColor: '#00897b',
      label: 'precio neto',
    },
    {
      key: 'peso',
      icon: <ScaleOutlinedIcon sx={{ fontSize: 20 }} />,
      iconColor: '#f9a825',
      value: formatPesoKg(pesoTotalKg),
      label: 'peso',
    },
    {
      key: 'volumen',
      icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      iconColor: '#e53935',
      value: formatVolumenM3(volumenTotalM3),
      label: 'volumen',
    },
  ];

  return <KpisBar items={items} ariaLabel={ariaLabel ?? `Resumen de ${cantidadLabel}`} />;
};

export default DocumentosKpisBar;
